import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Select, Modal, Tag, Popconfirm } from "antd";
const { Option } = Select;

const HotelEmailConfigList = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);



useEffect(() => {
    console.log(" useEffect running: fetching table data...");
    fetchData();
  }, []);

  useEffect(() => {
    console.log(" tableData updated:", tableData);
  }, [tableData]);
  

const fetchData = async () => {
    try {
      const response = await axios.get("https://stage-apiplatform.finkraftai.com/api/misc/followup/config/list");
      console.log(" Raw API response:", response.data);
  
      const dataList = Array.isArray(response.data?.data) ? response.data.data : response.data;
  
      if (Array.isArray(dataList)) {
        console.log(" Setting tableData with:", dataList);
        setTableData(dataList);
      } else {
        console.error(" Data is not an array:", dataList);
      }
    } catch (error) {
      console.error(" Error fetching config list:", error);
    }
  };

  
  

  const handleStatusChange = (newStatus: string, data: any) => {
    Modal.confirm({
      title: `Are you sure you want to change status to "${newStatus}"?`,
      onOk: async () => {
        try {
          const payload = {
            _id: data._id,
            status: newStatus,
          };
  
          console.log("Sending status update payload:", payload);
  
          const response = await axios.post(
            "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateStatus",
            payload
          );
  
          console.log("Status update response:", response.data);
          console.log("Current tableData before update:", tableData);

  
          const updatedData = tableData.map(item =>
            item._id === data._id ? { ...item, status: newStatus } : item
          );
  
          console.log("Updated table data:", updatedData);
  
          setTableData(updatedData);
  
          // Optional: instead of manually updating
          // await fetchData(); // uncomment if local update causes issues
  
          // Force refresh all rows
          gridRef.current?.api?.refreshCells({ force: true });
        } catch (error) {
          console.error("Failed to update status", error);
          Modal.error({
            title: "Update Failed",
            content: "There was an error updating the status. Please try again.",
          });
        }
      },
    });
  };
  
  

  const StatusCellRenderer = (props: any) => {
    const { data } = props;
  
    return (
      <Select
        value={data.status}
        onChange={(value) => handleStatusChange(value, data)}
        style={{ width: "120px" }}
      >
        <Option value="PENDING">PENDING</Option>
        <Option value="RUNNING">RUNNING</Option>
      </Select>
    );
  };
  

  // ActionCellRenderer component
  const ActionCellRenderer = (props: any) => {
    const { data } = props;
  
    const handleEdit = () => {
      console.log("Edit clicked for row:", data);
    
      navigate('/email_followup_config', { 
        state: { 
          action: 'edit',
          data: data
        }
      });
    };
  
    const handleDelete = async () => {
      console.log("Delete clicked for row:", data);
  
      if (!data._id) {
        console.error('No _id found for the selected row.');
        return;
      }
  
      try {
        const response = await axios.post(
          'https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/removeConfig',
          { _id: data._id }
        );
  
        console.log('Delete API response:', response.data);
  
        setTableData(prev => prev.filter(item => item._id !== data._id));
        
        alert('Deleted successfully!');
      } catch (error) {
        console.error('Error deleting config:', error);
        alert('Failed to delete. Please try again.');
      }
    };
  
    return (
        
      <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>

        <button 
          onClick={handleEdit}
          style={{
            padding: "4px 12px",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Edit
        </button>
        <Popconfirm
        title="Are you sure you want to delete this config?"
        onConfirm={handleDelete}
        okText="Yes"
        cancelText="No"
      >
        <button
          style={{
            padding: "4px 12px",
            backgroundColor: "#d32f2f",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Delete
        </button>
      </Popconfirm>
      </div>
    );
  };
  

  // Column definitions
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Config Name",
        field: "name",
        minWidth: 750,
        cellStyle: { fontWeight: "500" },
      },
      {
        headerName: "Status",
        field: "status",
        minWidth: 300,
        cellRenderer: StatusCellRenderer,
        cellStyle: { fontWeight: "500", textAlign: "center" },
      },
      {
        headerName: "Action",
        field: "action",
        minWidth: 300,
        cellRenderer: ActionCellRenderer,
        cellStyle: { fontWeight: "500", textAlign: "center" },
      }
    ],
    []
  );

  return (
    <>
      <PageHeader title="Hotel Email Configurations List" />
      <AgTableClient
      ref={gridRef}
      //@ts-ignore       
        rowData={tableData}
        columnDefs={columnDefs}
        groupPanel
        enablePDFViewer
        pdfDataKey="S3 Link"
        defaultPivot={[""]}
        getRowId={(params:any) => params.data._id}
        // showExport
      />
    </>
  );
};

export default HotelEmailConfigList;